import { createApp } from 'vue'
import App from './App.vue'
import mitt from 'mitt'
// import VueJsonLD from 'vue-jsonld'
import VueGtag from 'vue-gtag-next'
import router from './router'
import "./index.css";

const emitter = mitt()
const app = createApp(App)
app.config.globalProperties.emitter = emitter
app.use(router);
// app.use(VueJsonLD);
app.use(VueGtag, {
    property: {
        id: 'G-HTM0Y8VR15',
    }
});
app.mount('#app');


